import { mapActions } from "vuex"

export default {
    data() {
        return {
            loadingCatalogues: false,
        }
    },
    async created() {
        await this.loadCatalogues()
    },
    methods: {
        ...mapActions(["FETCH_CATALOGUE"]),
        async loadCatalogues() {
            if (this.once && this.loaded) {
                return;
            }
            this.loadingCatalogues = true
            await Promise.all(this.cataloguesToLoad.map(key => this.FETCH_CATALOGUE(key)))
            this.loadingCatalogues = false
        },
    }

}